module.exports = __webpack_public_path__ + "static/cruiser-dab37fdb30afc518c7357182f5a80394.png";